import { useMutation } from '@tanstack/react-query';

import { MembershipTypeFormSchemaValues } from 'src/features/membershipType/formSchema';
import { MembershipType } from 'src/features/membershipType/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/memberships/membership-type/:id/`;

type MutationFnType = typeof mutationFn;

interface DTO extends MembershipTypeFormSchemaValues {
    parkingId: string;
    id: string;
}
const mutationFn = ({ parkingId, id, ...data }: DTO): Promise<MembershipType> => {
    return axios.put(formatResourcePath(RESOURCE, { parkingId, id }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateMembershipType };
